import {useEffect, useRef} from "react"
import {useIdleTimeoutContext} from "react-idle-timeout"

import {getJwtExpiryTime} from "../utilities/useToken"
import {wrappedPost} from "../utilities/AxiosHelper"

// Renew when less than this remains. Must be below the token lifetime (30 min)
// and above the idle warning plus a few minutes.
export const RENEW_WHEN_REMAINING_MS = 15 * 60 * 1000
// Local check only (reads the stored token), no network call
export const KEEPALIVE_CHECK_MS = 60 * 1000

/**
 * Keeps the access token fresh while the page is open.
 *
 * The idle timer resets on any mouse/keyboard activity, but the server only renews
 * the token on API calls. This checks the stored token's expiry and renews it
 * when it runs low. Must be rendered inside IdleTimeoutProvider.
 */
function SessionKeepAlive() {
    const inFlight = useRef(false)
    const {isWarning} = useIdleTimeoutContext()

    useEffect(() => {
        // While the warning modal is open, its own buttons control the session
        if (isWarning) {
            return
        }

        const id = setInterval(() => {
            if (inFlight.current) {
                return
            }
            const expiry = getJwtExpiryTime()
            if (expiry && expiry - Date.now() < RENEW_WHEN_REMAINING_MS) {
                inFlight.current = true
                wrappedPost("/update-token")
                    .catch(() => {})
                    .finally(() => {
                        inFlight.current = false
                    })
            }
        }, KEEPALIVE_CHECK_MS)

        return () => clearInterval(id)
    }, [isWarning])

    return null
}

export default SessionKeepAlive
